const FacetSearchLocationSlice = {
  changed: false,
  fullLocationList: [],
  searchLocations: [],
  selectedLocation: null,
  selectedLocationCodes: []
};

window.FacetSearchLocationSlice = FacetSearchLocationSlice
export { FacetSearchLocationSlice }